module.exports = __webpack_public_path__ + "img/no-avatar.c3a9e685.svg";